<div class="p-a-xl">
    <h2>Cipo Text Fields</h2>

    <div fxLayout="row wrap" fxLayoutGap="12px">
        @for (control of form().controls | keyvalue; track $index) {
            <div fxFlex="30" fxFlexAlign="end" class="m-t">
                <cipo-autocomplete [control]="control.value" />
            </div>
        }
    </div>
    <div class="m-t-xl">
        <p class="cipo-text--accent-800 m-b">
            Playground for Formula Autocomplete. Select an option from dropdown, or write (number or available
            operators) and press SPACE to insert it
        </p>
        <mat-form-field appearance="outline" class="formula-autocomplete">
            <mat-label>Formula Autocomplete</mat-label>
            <mat-chip-grid #chipGrid [formControl]="formulaAutocomplete">
                @for (option of formulaAutocomplete.value; track option) {
                    <mat-chip-row
                        (removed)="remove(option)"
                        [value]="option"
                        [class.operator]="operators.includes(option.replace(':', ''))">
                        {{ optionsDict[option] || option | translate }}
                        <button matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                }
            </mat-chip-grid>
            <input
                [value]="searchCriteria()"
                (input)="searchCriteria.set($any($event.target).value)"
                [matChipInputFor]="chipGrid"
                [matAutocomplete]="auto"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)" />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                @for (option of availableOptions(); track option) {
                    <mat-option [value]="option.key">
                        {{ option.value | translate }}
                    </mat-option>
                }
            </mat-autocomplete>
            <mat-hint>Press # to see fields only, and : to see operators only</mat-hint>
        </mat-form-field>
        <div class="m-t">
            Formula:
            <span class="cipo-text--bold-md">{{ formulaValue$ | async }}</span>
        </div>
    </div>
</div>
